'use client'

import React, { createContext } from 'react'

import { useFilteredItems } from '~/components/hooks/use-filtered-items'

type PromotionContextType = {
  promotionsLoading: boolean
  totalItems: number
}

export const PromotionsContext = createContext<PromotionContextType>({
  promotionsLoading: true,
  totalItems: 0,
})

type PromotionsProviderProps = {
  children: React.ReactNode
}

const PromotionsProvider: React.FC<PromotionsProviderProps> = ({
  children,
}: PromotionsProviderProps) => {
  const { loading: isItemsLoading, totalItems } = useFilteredItems({
    isPromotion: true,
  })

  return (
    <PromotionsContext.Provider
      value={{
        promotionsLoading: isItemsLoading,
        totalItems: totalItems ?? 0,
      }}
    >
      {children}
    </PromotionsContext.Provider>
  )
}

export { PromotionsProvider }
